import { get } from '../request';
import { APP_CONFIG } from '../../config';

export const getSession = async () => {
  return await get(`${APP_CONFIG.baseApiUrl}/konto/api/client/session?isMeinPlusApp=true`, 'XSRF-TOKEN');
};
